import _extends from "@babel/runtime/helpers/extends";
import Lozenge from '@atlaskit/lozenge';
import Tabs, { TabList, TabPanel, useTab } from '@atlaskit/tabs';
import React from 'react';
import { HorizontalScrollShadow, StyledLozenge, TabListContainer } from './ResponsiveTabs.styles';
export const Tab = _ref => {
  let {
    children,
    testId
  } = _ref;
  const tabAttributes = useTab();
  return /*#__PURE__*/React.createElement("div", _extends({}, tabAttributes, {
    "data-testid": testId
  }), children);
};
const TabLozenge = _ref2 => {
  let {
    appearance,
    label
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledLozenge, null, /*#__PURE__*/React.createElement(Lozenge, {
    appearance: appearance
  }, label));
};

/**
 * A wrapper over Atlaskit tabs that allows additional tabs to
 * be horizontally scrollable if the screen size is too small.
 *
 */
export default function ResponsiveTabs(props) {
  const openTabs = props.tabs;
  const selectedTabIndex = typeof props.selected === 'number' ? props.selected : props.tabs.findIndex(tab => tab.key === props.selected);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props === null || props === void 0 ? void 0 : props.afterTabs, /*#__PURE__*/React.createElement(HorizontalScrollShadow, null), /*#__PURE__*/React.createElement(Tabs, {
    id: props.id,
    testId: props.testId,
    selected: selectedTabIndex,
    onChange: tabIndex => props.onChange(props.tabs[tabIndex])
  }, /*#__PURE__*/React.createElement(TabListContainer, {
    showAetherAppListingPage: props.showAetherAppListingPage
  }, /*#__PURE__*/React.createElement(TabList, null, openTabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.key,
    testId: tab.testId
  }, tab.label, !!tab.lozenge && /*#__PURE__*/React.createElement(TabLozenge, tab.lozenge))))), props.tabs.map(tab => /*#__PURE__*/React.createElement(TabPanel, {
    key: tab.key
  }, tab.content))));
}